import { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useCreateFidelizationConfiguration } from "../../hooks/useCreateFidelizationConfiguration";
import { useFidelizationConfiguration } from "../../hooks/useFidelizationConfiguration";


interface ParameterFormFidelizacionProps {
  onSuccess?: () => void;
}

export const ParameterFormFidelizacion = ({
  onSuccess,
}: ParameterFormFidelizacionProps) => {
  const [permanenceValue, setPermanenceValue] = useState("");
  const [permanenceUnit, setPermanenceUnit] = useState<"YEARS" | "MONTHS" | "">("");



  const [errors, setErrors] = useState({
    permanenceValue: "",
    permanenceUnit: "",
  });

  const { data: currentConfig, loading: loadingConfig } = useFidelizationConfiguration();
  const { saveConfiguration, loading } = useCreateFidelizationConfiguration();

  

  useEffect(() => {
   const config = currentConfig;
    if (!config) return;

    setPermanenceValue(String(config.permanenceValue ?? ""));
    setPermanenceUnit(config.permanenceUnit ?? "");
  }, [currentConfig]);
  const validate = () => {
    const newErrors = {
      permanenceValue: "",
      permanenceUnit: "",
    };

    if (!permanenceValue) {
  newErrors.permanenceValue = "La permanencia es obligatoria";
} else if (!/^\d+$/.test(permanenceValue)) {
  newErrors.permanenceValue = "La permanencia debe ser un número entero";
} else if (Number(permanenceValue) <= 0) {
  newErrors.permanenceValue = "La permanencia debe ser mayor a 0";
} else if (permanenceUnit === "YEARS" && Number(permanenceValue) > 10) {
  newErrors.permanenceValue =
    "La permanencia en años no puede superar 10 años";
} else if (permanenceUnit === "MONTHS" && Number(permanenceValue) > 120) {
  newErrors.permanenceValue =
    "La permanencia en meses no puede superar 120 meses";
}

    if (!permanenceUnit) {
      newErrors.permanenceUnit = "La unidad es obligatoria";
    }
    setErrors(newErrors);
    return Object.values(newErrors).every((value) => !value);
  };

  const handleSubmit = () => {
    if (!validate()) return;
    saveConfiguration(
      {
        permanenceValue: Number(permanenceValue),
        permanenceUnit: permanenceUnit as "YEARS" | "MONTHS",
      },
      {
        onSuccess: () => {
          setErrors({
            permanenceValue: "",
            permanenceUnit: "",
          });
          onSuccess?.();
        },
      } as any
    );
  };

  return (
    <Box>
      <Typography variant="h6" fontWeight={700} mb={3}>
        Parametrización de Fidelización
      </Typography>

      <Stack spacing={3}>
        <TextField
          label="Tiempo de permanencia"
          type="text"
          value={permanenceValue}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              setPermanenceValue(value);
            }
          }}
          error={!!errors.permanenceValue}
          helperText={
            errors.permanenceValue ||
            (permanenceUnit === "MONTHS"
              ? "Ingrese un valor entre 1 y 120 meses"
              : permanenceUnit === "YEARS"
                ? "Ingrese un valor entre 1 y 10 años"
                : "Seleccione la unidad para validar el rango")
          }
          fullWidth
          required
          disabled={loading || loadingConfig}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 3 }}
        />

        <FormControl fullWidth required error={!!errors.permanenceUnit}>
          <InputLabel>Unidad</InputLabel>
          <Select
            value={permanenceUnit}
            label="Unidad"
              onChange={(e) => {
                setPermanenceUnit(e.target.value as "YEARS" | "MONTHS");
                setErrors((prev) => ({
                  ...prev,
                  permanenceUnit: "",
                  permanenceValue: "",
                }));
              }}
            disabled={loading || loadingConfig}
          >
            <MenuItem value="YEARS">Años</MenuItem>
            <MenuItem value="MONTHS">Meses</MenuItem>
          </Select>
          <FormHelperText>{errors.permanenceUnit}</FormHelperText>
        </FormControl>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={loading || loadingConfig}
        >
          {loading ? "Guardando..." : "Guardar"}
        </Button>
      </Stack>
    </Box>
  );
};